document.addEventListener('DOMContentLoaded', function() {
  console.log("DOM fully loaded and parsed");

  const addToCartButton = document.querySelector('.varaiant_disable');
  console.log("Add to Cart button selected:", addToCartButton);

  // Function to check the quantity and update the button state
  function updateButtonState() {
    console.log("Running updateButtonState...");

    const selectedOption = document.querySelector('.ColorSwatch__Radio:checked');
    console.log("Selected color swatch option:", selectedOption);

    if (selectedOption) {
      const quantity = parseInt(selectedOption.closest('.HorizontalList__Item').getAttribute('data-variant-quantity'), 10);
      console.log("Selected variant quantity:", quantity);

      if (quantity > 0) {
        console.log("Variant is in stock. Enabling Add to Cart button.");
        addToCartButton.disabled = false;
        addToCartButton.textContent = "Add To Cart";
        addToCartButton.classList.remove('Button--disabled');
      } else {
        console.log("Variant is out of stock. Disabling Add to Cart button.");
        addToCartButton.disabled = true;
        addToCartButton.textContent = "Out of Stock";
        addToCartButton.classList.add('Button--disabled');
      }
    } else {
      console.log("No color swatch option selected.");
    }
  }

  // Run the function once on page load to check the initially selected variant
  console.log("Checking initial variant on page load...");
  updateButtonState();

  // Add click event listeners to all radio buttons
  document.querySelectorAll('.ColorSwatch__Radio').forEach((radio) => {
    console.log("Adding event listener to radio button:", radio);
    radio.addEventListener('change', updateButtonState);
  });
});
